<template>
  <base-users>
    <template v-slot:default>
      <v-card class="card-user mx-0 my-4 d-inline-block pb-0">
        <div class="card-user_block d-inline-flex flex-wrap position-relative">
          <div class="card-user_avatar" v-if="getProfileImgUrl">
            <img :src="getProfileImgUrl" alt="Profile Image">
          </div>
          <div class="card-user_avatar" v-else>
            <v-icon class="card-user_avatar_icon" color="#fff" large>mdi-account-circle</v-icon>
          </div>
          <div class="card-user_content">
            <h3 class="card-user_name mb-5">{{ staff.name }}
              <!-- <span class="fs-14 font-weight-regular pl-3" v-if="staff.crmRep == true">{{ $t("users.crmRep") }}</span> -->
              </h3>
            <!-- <p class="fs-14 font-weight-medium">{{ staff.name }}</p> -->
            <p class="card-user_txt mb-0">{{ $t("users.email") }}</p>
            <p class="fs-14 font-weight-bold mb-0">{{ staff.email }}</p>
            <!-- <p class="card-user_txt mb-0 pt-2">{{ $t("users.lastLogin") }}</p>
            <p class="fs-14 font-weight-bold mb-0">{{ staff.lastLoginAt }}</p> -->
          </div>
        </div>
      </v-card>

      <v-card v-if="hasAdminFuncPermission" class="my-4">
        <v-card-title>{{ $t("users.adminFunctions") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="admin-function">
            <v-form v-model="changeInvoiceDate.valid" lazy-validation>
              {{ $t("users.changeInvoiceDate") }}
              <v-text-field
                label="請求書ID"
                v-model="changeInvoiceDate.invoiceId"
                type="number"
                :rules="[$rules.required, $rules.checkNumber]"
              ></v-text-field>
              <v-btn color="primary"
                :disabled="!changeInvoiceDate.valid"
                @click="changeInvoiceDateAction"
              >
                請求書を取得
              </v-btn>
            </v-form>
            <v-dialog v-if="oldInvoice" :value="!!oldInvoice" @input="oldInvoice = null" max-width="600px">
              <v-card>
                <v-card-title>{{ $t("users.changeInvoiceDate") }}</v-card-title>
                <v-card-text>
                  <div>
                    <div>現発行日時: {{ formatDateTime(oldInvoice.finalizedAt) }}</div>
                  </div>
                  <DateTimePicker
                    v-model="changeInvoiceDate.newDate"
                    :format="dateTimeFormat"
                    label="新発行日時"
                  ></DateTimePicker>
                  <iframe
                    v-if="oldInvoice.pdfFileUrl"
                    :src="oldInvoice.pdfFileUrl"
                    width="100%"
                    height="500px"
                  ></iframe>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="oldInvoice = null"
                    color="error"
                  >
                    キャンセル
                  </v-btn>
                  <v-btn
                    :disabled="!changeInvoiceDate.newDate"
                    @click="runChangeInvoiceDate"
                    color="primary"
                  >
                    日時変更実行
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-card-text>

      </v-card>
    </template>
  </base-users>
</template>

<script>
import moment from 'moment'
import BaseUsers from '../../../../components/Users/BaseUsers'
import { STAFF } from '@/api/graphql/staff/staff-info'
import { mapGetters, mapActions } from 'vuex'
import gql from 'graphql-tag'
import { pdfUrlHideScrollbar } from '@/utils/urls'
import DateTimePicker from '../../../../components/Input/DateTimePicker.vue'
import { hasAdminFuncPermission } from '../../../../utils/permissions';

export default {
  name: 'UserInformation',
  data () {
    return {
      staff: {
        name: null,
        email: null
      },
      profileImgUrl: null,
      changeInvoiceDate: {
        valid: false,
        invoiceId: null,
        newDate: null,
      },
      oldInvoice: null,
    }
  },
  mounted () {
    this.getUserInformation()
    // get Avatar
    this.actionGetProfileImgUrl()
  },
  // watch: {
  //   getProfileImgUrl () {
  //     console.log('getProfileImgUrl', this.getProfileImgUrl)
  //   }
  // },
  computed: {
    ...mapGetters(['getProfileImgUrl']),
    dateTimeFormat () {
      return 'YYYY-MM-DD HH:mm'
    },
    hasAdminFuncPermission() {
      return hasAdminFuncPermission();
    },
    invoiceId() {
      // this.changeInvoiceDate.invoiceId is string, convert to number
      // if empty, return null
      return this.changeInvoiceDate.invoiceId ? Number(this.changeInvoiceDate.invoiceId) : null
    },
  },
  components: {
    BaseUsers, DateTimePicker
  },
  methods: {
    ...mapActions(['actionGetProfileImgUrl']),
    getUserInformation () {
      this.$apollo.query({
        query: gql`${STAFF}`,
        variables: {
          id: parseInt(localStorage.getItem('id') || 1)
        },
        fetchPolicy: 'no-cache'
      }).then((data) => {
        this.staff = data.data.staff
      }).catch((error) => {
        console.error(error)
      })
    },
    async changeInvoiceDateAction () {
      // get the invoice PDF and show it to user for confirmation.
      const result = await this.$apollo.query({
        query: gql`query ($id: Int!) {
          bookingInvoice(id: $id) {
            id
            finalizedAt #発行登録した日時
            pdfFileUrl #ダウンロード可能なPDFファイル
          }
        }`,
        variables: { id: this.invoiceId },
        fetchPolicy: 'no-cache',
      });

      if (result && result.data && result.data.bookingInvoice) {
        const invoice = result.data.bookingInvoice;
        if (!invoice.finalizedAt) {
          this.$toast.error('指定された請求書IDの請求明細書はまだ発行登録されていません。請求明細画面より請求書を削除して対応してください。');
        } else {
          this.oldInvoice = invoice;
          this.oldInvoice.pdfFileUrl = pdfUrlHideScrollbar(this.oldInvoice.pdfFileUrl);
        }
      } else {
        this.$toast.error('指定された請求書IDの請求明細書が見つかりません。');
      }
    },
    async runChangeInvoiceDate() {
      // execute the change of invoice date.
      await this.$gqlLoading({
        query: gql`mutation changeBookingInvoiceDate (
            $invoiceId: Int!
            $newDate: DateTime!
        ) {
            changeBookingInvoiceDate(
                data: {
                    bookingInvoiceId: $invoiceId
                    newInvoiceDate: $newDate
                }
            ) {
                id
            }
        }`,
        variables: {
          invoiceId: this.oldInvoice.id,
          newDate: moment(this.changeInvoiceDate.newDate).toISOString(),
        },
      }).then((data) => {
        this.$toast.success('請求明細書の発行日時を変更しました。');
        this.changeInvoiceDate = {
          ...this.changeInvoiceDate,
          newDate: null,
        };
        this.oldInvoice = null;
      })
    },
    formatDateTime (dateTime) {
      return moment(dateTime).format(this.dateTimeFormat)
    },
  },
}
</script>

<style scoped lang="scss">
.card-user_avatar {
  background: none;
  border-radius: 50% !important;
  height: 126px;
  width: 126px;
  img {
    width: 126px;
    height: 126px;
    margin-right: 30px;
    border-radius: 50% !important;
  }
}
.card-user_block {
  border: 0;
}
.card-user_content {
  color: #000;
}
.card-user_txt {
  font-size: 10px;
}
</style>
